import {FC, HTMLAttributes} from 'react'

export const PauseIcon: FC<{size?: number} & HTMLAttributes<SVGSVGElement>> = ({size = 20, ...rest}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest}>
            <path
                d="M7.91669 12.4993V7.49935M12.0834 12.4993V7.49935M18.3334 9.99935C18.3334 14.6017 14.6024 18.3327 10 18.3327C5.39765 18.3327 1.66669 14.6017 1.66669 9.99935C1.66669 5.39698 5.39765 1.66602 10 1.66602C14.6024 1.66602 18.3334 5.39698 18.3334 9.99935Z"
                stroke="#D92D20"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
